const sideBarStyle = {
  container: {
    paddingRight: "5px"
  },
  menuButton: {
    cursor:"pointer"
  },
  linkList: {
    display: "flex",
    flexDirection: "column",
  }
}

export default sideBarStyle;
